// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"letters-m"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M19 19L19 6C19 5.44772 18.5523 5 18 5L12 5M12 5L12 19M12 5L5 5L5 19","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const LettersMIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'letters-m',
    ref,
    icon: element,
  },
));

LettersMIcon.displayName = 'LettersMIcon';

export default LettersMIcon;
